module.exports = __webpack_public_path__ + "static/media/aba.24b8fad1.png";